var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-listing-actions" },
    [
      _vm.showActionsMenu
        ? _c(
            "CompassMenu",
            {
              attrs: {
                trigger: "click",
                customClass: "email-listing-actions__menu"
              }
            },
            [
              _c("CompassIconButton", { attrs: { icon: "action" } }),
              _vm._v(" "),
              _c(
                "template",
                { slot: "dropdown" },
                [
                  _vm.isReceivedTableOrSentTable
                    ? _c("CompassMenuItem", {
                        attrs: {
                          label: _vm.$t.__("common.actions.display"),
                          disabled: !_vm.email.canRead
                        },
                        on: { click: _vm.handleOpenEmail }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isReceivedTableOrSentTable
                    ? _c("CompassMenuItem", {
                        attrs: {
                          label: _vm.$t.__("common.actions.manage_related"),
                          disabled: !_vm.email.canUpdateRelated
                        },
                        on: { click: _vm.handleOpenRelated }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isReceivedTable
                    ? _c("CompassMenuItem", {
                        attrs: {
                          label: _vm.changeReadingStatusButtonLabel,
                          disabled: !_vm.email.canUpdate
                        },
                        on: { click: _vm.handleUpdateReadingStatus }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOutboxTable
                    ? _c("CompassMenuItem", {
                        attrs: {
                          label: _vm.$t.__("common.actions.resend"),
                          disabled: _vm.email.status !== "failed_to_send"
                        },
                        on: { click: _vm.handleResend }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showDeleteActions
                    ? _c("CompassMenuItem", {
                        attrs: { label: _vm.$t.__("common.actions.delete") },
                        on: { click: _vm.handleDelete }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }